(function() {
  var WIDGET_SELECTOR = '[data-plan-select-widget]';
  var widgetRegistry = [];
  var variantSubscription = null;

  function parseJSON(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, locale, currency) {
    var amount = Number(cents || 0) / 100;
    if (!Number.isFinite(amount)) amount = 0;

    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function clamp(value, min, max) {
    var next = Number(value || 0);
    if (!Number.isFinite(next)) next = min;
    if (next < min) return min;
    if (next > max) return max;
    return next;
  }

  function getVariantById(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;
    var target = String(variantId || '');

    for (var i = 0; i < product.variants.length; i += 1) {
      var variant = product.variants[i];
      if (String(variant.id) === target) return variant;
    }

    return product.variants[0] || null;
  }

  function normalizeSellingPlans(product, variant) {
    if (!product || !variant || !Array.isArray(product.selling_plan_groups)) return [];

    var allocations = Array.isArray(variant.selling_plan_allocations) ? variant.selling_plan_allocations : [];
    var allocationMap = {};

    for (var i = 0; i < allocations.length; i += 1) {
      var allocation = allocations[i];
      if (!allocation) continue;
      var key = String(allocation.selling_plan_id || allocation.id || '');
      if (!key) continue;
      allocationMap[key] = allocation;
    }

    var plans = [];
    for (var g = 0; g < product.selling_plan_groups.length; g += 1) {
      var group = product.selling_plan_groups[g];
      if (!group || !Array.isArray(group.selling_plans)) continue;

      for (var p = 0; p < group.selling_plans.length; p += 1) {
        var plan = group.selling_plans[p];
        if (!plan || !plan.id) continue;

        var planId = String(plan.id);
        var matchedAllocation = allocationMap[planId] || null;
        if (allocations.length > 0 && !matchedAllocation) continue;

        plans.push({
          id: planId,
          name: plan.name || group.name || 'Subscription',
          allocation: matchedAllocation,
        });
      }
    }

    return plans;
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function createBubblingEvent(name) {
    try {
      return new Event(name, { bubbles: true });
    } catch (error) {
      var legacy = document.createEvent('Event');
      legacy.initEvent(name, true, false);
      return legacy;
    }
  }

  function PlanSelectWidget(root) {
    this.root = root;
    this.sectionId = String(root.getAttribute('data-section-id') || '');
    this.formId = root.getAttribute('data-product-form-id') || '';
    this.currency = root.getAttribute('data-currency') || 'USD';
    this.locale = root.getAttribute('data-locale') || undefined;
    this.priceSuffix = root.getAttribute('data-price-suffix') || '';
    this.savePrefix = root.getAttribute('data-save-prefix') || 'Save';
    this.showSave = root.getAttribute('data-show-save') === 'true';
    this.emptyText = root.getAttribute('data-empty-text') || 'No subscription plans available for this variant.';
    this.defaultBonusLabel = root.getAttribute('data-default-bonus-label') || '';
    this.defaultBonusStrong = root.getAttribute('data-default-bonus-strong') || '';

    this.listNode = root.querySelector('[data-plan-select-list]');
    this.emptyNode = root.querySelector('[data-plan-select-empty]');
    this.planInput = root.querySelector('[data-plan-select-input]');

    this.product = parseJSON(root.querySelector('[data-plan-select-product]'));
    this.overrides = parseJSON(root.querySelector('[data-plan-select-overrides]'));
    if (!Array.isArray(this.overrides)) this.overrides = [];

    this.selectedVariantId = String(root.getAttribute('data-selected-variant-id') || '');
    this.selectedPlanId = '';

    this.defaultIndex = clamp(root.getAttribute('data-default-selected-position') || 1, 1, 6) - 1;

    this.variantInput = null;
    if (this.formId) {
      var productForm = document.getElementById(this.formId);
      if (productForm) this.variantInput = productForm.querySelector('input[name="id"]');
    }
    this.handleCardClick = this.handleCardClick.bind(this);
    this.handleVariantInputChange = this.handleVariantInputChange.bind(this);

    this.attachListeners();
    this.refresh();
  }

  PlanSelectWidget.prototype.getOverride = function(index) {
    return this.overrides[index] || null;
  };

  PlanSelectWidget.prototype.getActiveVariant = function() {
    var variantId = this.selectedVariantId;
    if (this.variantInput && this.variantInput.value) variantId = this.variantInput.value;
    return getVariantById(this.product, variantId);
  };

  PlanSelectWidget.prototype.attachListeners = function() {
    if (this.listNode) {
      this.listNode.addEventListener('click', this.handleCardClick);
    }

    if (this.variantInput) {
      this.variantInput.addEventListener('change', this.handleVariantInputChange);
    }
  };

  PlanSelectWidget.prototype.handleCardClick = function(event) {
    var optionNode = event.target.closest('[data-plan-option]');
    if (!optionNode || !this.listNode.contains(optionNode)) return;

    this.selectedPlanId = String(optionNode.getAttribute('data-plan-id') || '');
    this.syncPlanInput();
    this.render();
  };

  PlanSelectWidget.prototype.handleVariantInputChange = function(event) {
    this.onVariantChange(this.sectionId, event.target ? event.target.value : '');
  };

  PlanSelectWidget.prototype.syncPlanInput = function() {
    if (!this.planInput) return;

    if (!this.selectedPlanId) {
      this.planInput.value = '';
      this.planInput.disabled = true;
      this.planInput.dispatchEvent(createBubblingEvent('input'));
      this.planInput.dispatchEvent(createBubblingEvent('change'));
      this.emitSelectionChanged();
      return;
    }

    this.planInput.value = this.selectedPlanId;
    this.planInput.disabled = false;
    this.planInput.dispatchEvent(createBubblingEvent('input'));
    this.planInput.dispatchEvent(createBubblingEvent('change'));
    this.emitSelectionChanged();
  };

  PlanSelectWidget.prototype.emitSelectionChanged = function() {
    var detail = {
      sectionId: this.sectionId,
      planId: this.selectedPlanId || '',
      variantId: this.variant && this.variant.id ? String(this.variant.id) : '',
    };

    this.root.dispatchEvent(
      new CustomEvent('plan-select:change', {
        bubbles: true,
        detail: detail,
      })
    );
  };

  PlanSelectWidget.prototype.getPlanViewModel = function(plan, index, variant) {
    var override = this.getOverride(index) || {};
    var allocation = plan && plan.allocation ? plan.allocation : null;

    var variantPrice = Number((variant && variant.price) || 0);
    var variantCompare = Number((variant && variant.compare_at_price) || 0);
    if (variantCompare < variantPrice) variantCompare = variantPrice;

    var planPrice = Number((allocation && allocation.price) || variantPrice);
    var planCompare = Number((allocation && allocation.compare_at_price) || variantCompare || variantPrice);
    if (planCompare < planPrice) planCompare = planPrice;

    var saveAmount = Math.max(0, planCompare - planPrice);

    return {
      id: String(plan.id),
      title: (override.title || plan.name || '').trim(),
      badge: (override.badge || '').trim(),
      badgeStart: (override.badgeStart || '').trim(),
      badgeEnd: (override.badgeEnd || '').trim(),
      price: (override.price || '').trim(),
      priceText: (override.price || '').trim() || formatMoney(planPrice, this.locale, this.currency),
      periodText: this.priceSuffix,
      saveText: (override.save || '').trim(),
      computedSaveText: saveAmount > 0 ? this.savePrefix + ' ' + formatMoney(saveAmount, this.locale, this.currency) : '',
      showSave: this.showSave,
      bonusLabel: (override.bonusLabel || this.defaultBonusLabel || '').trim(),
      bonusStrong: (override.bonusStrong || this.defaultBonusStrong || '').trim(),
      bonusTitle: (override.bonusTitle || '').trim(),
      bonusValue: (override.bonusValue || '').trim(),
      bonusText: (override.bonusText || '').trim(),
      bonusImage: (override.bonusImage || '').trim(),
      bonusImageAlt: (override.bonusImageAlt || '').trim(),
    };
  };

  PlanSelectWidget.prototype.refresh = function() {
    if (!this.product || !this.listNode) return;

    this.variant = this.getActiveVariant();
    this.plans = normalizeSellingPlans(this.product, this.variant);

    if (!this.plans.length) {
      this.selectedPlanId = '';
      this.syncPlanInput();
      this.listNode.innerHTML = '';
      if (this.emptyNode) {
        this.emptyNode.hidden = false;
        this.emptyNode.textContent = this.emptyText;
      }
      return;
    }

    if (this.emptyNode) this.emptyNode.hidden = true;

    var hasCurrentSelection = false;
    for (var i = 0; i < this.plans.length; i += 1) {
      if (String(this.plans[i].id) === String(this.selectedPlanId)) {
        hasCurrentSelection = true;
        break;
      }
    }

    if (!hasCurrentSelection) {
      var fallbackPlan = this.plans[this.defaultIndex] || this.plans[0];
      this.selectedPlanId = fallbackPlan ? String(fallbackPlan.id) : '';
    }

    this.syncPlanInput();
    this.render();
  };

  PlanSelectWidget.prototype.render = function() {
    var self = this;
    if (!self.listNode || !Array.isArray(self.plans)) return;

    self.listNode.innerHTML = '';

    self.plans.forEach(function(plan, index) {
      var view = self.getPlanViewModel(plan, index, self.variant);
      var isActive = String(view.id) === String(self.selectedPlanId);

      var card = createElement('button', 'plan-select__option' + (isActive ? ' is-active' : ''), '');
      card.type = 'button';
      card.setAttribute('data-plan-option', '');
      card.setAttribute('data-plan-id', view.id);
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', isActive ? 'true' : 'false');

      var top = createElement('div', 'plan-select__top', '');
      var left = createElement('div', '', '');
      var titleRow = createElement('div', 'plan-select__title-row', '');
      var title = createElement('h4', 'plan-select__title', view.title);
      titleRow.appendChild(title);

      if (view.badge) {
        var badge = createElement('span', 'plan-select__badge', view.badge);
        if (view.badgeStart || view.badgeEnd) {
          var start = view.badgeStart || 'var(--ps-badge-start)';
          var end = view.badgeEnd || 'var(--ps-badge-end)';
          badge.style.background = 'linear-gradient(90deg, ' + start + ', ' + end + ')';
        }
        titleRow.appendChild(badge);
      }

      var right = createElement('div', 'plan-select__price-wrap', '');
      var priceLine = createElement('div', 'plan-select__price-line', '');
      priceLine.appendChild(createElement('span', 'plan-select__price', view.priceText));

      if (view.periodText) {
        priceLine.appendChild(createElement('span', 'plan-select__period', view.periodText));
      }

      var saveText = '';
      if (view.showSave) {
        saveText = view.saveText || view.computedSaveText;
      }

      var pricePosition = self.root.getAttribute('data-desktop-price-position') || 'end';

      if (pricePosition === 'beside') {
        titleRow.appendChild(priceLine);
        left.appendChild(titleRow);

        if (saveText) {
          left.appendChild(createElement('p', 'plan-select__save', saveText));
        }

        top.appendChild(left);
      } else if (pricePosition === 'under') {
        left.appendChild(titleRow);
        right.appendChild(priceLine);

        if (saveText) {
          right.appendChild(createElement('p', 'plan-select__save', saveText));
        }

        left.appendChild(right);
        top.appendChild(left);
      } else {
        left.appendChild(titleRow);
        right.appendChild(priceLine);

        if (saveText) {
          right.appendChild(createElement('p', 'plan-select__save', saveText));
        }

        top.appendChild(left);
        top.appendChild(right);
      }

      card.appendChild(top);

      var hasBonusContent = !!(view.bonusLabel || view.bonusStrong || view.bonusTitle || view.bonusValue || view.bonusText || view.bonusImage);
      var bonusClass = 'plan-select__bonus' + (hasBonusContent ? ' has-content' : '') + (view.bonusImage ? ' has-image' : '');
      var bonus = createElement('div', bonusClass, '');

      if (hasBonusContent) {
        var bonusCopy = createElement('div', 'plan-select__bonus-copy', '');

        if (view.bonusLabel) {
          bonusCopy.appendChild(createElement('p', 'plan-select__bonus-label', view.bonusLabel));
        }

        if (view.bonusStrong) {
          bonusCopy.appendChild(createElement('p', 'plan-select__bonus-strong', view.bonusStrong));
        }

        if (view.bonusTitle) {
          bonusCopy.appendChild(createElement('p', 'plan-select__bonus-title', view.bonusTitle));
        }

        if (view.bonusValue) {
          bonusCopy.appendChild(createElement('span', 'plan-select__bonus-value', view.bonusValue));
        }

        if (view.bonusText) {
          bonusCopy.appendChild(createElement('p', 'plan-select__bonus-text', view.bonusText));
        }

        bonus.appendChild(bonusCopy);

        if (view.bonusImage) {
          var bonusMedia = createElement('div', 'plan-select__bonus-image', '');
          var image = document.createElement('img');
          image.src = view.bonusImage;
          image.loading = isActive ? 'eager' : 'lazy';
          image.decoding = 'async';
          if (isActive) {
            image.setAttribute('fetchpriority', 'high');
          }
          image.alt = view.bonusImageAlt || view.bonusTitle || view.title;
          bonusMedia.appendChild(image);
          bonus.appendChild(bonusMedia);
        }
      }

      card.appendChild(bonus);
      self.listNode.appendChild(card);
    });

    self.ensureActiveBonusImagesLoad();
  };

  PlanSelectWidget.prototype.ensureActiveBonusImagesLoad = function() {
    var self = this;
    if (!self.listNode) return;

    window.requestAnimationFrame(function() {
      if (!self.listNode) return;

      var activeImage = self.listNode.querySelector('.plan-select__option.is-active .plan-select__bonus-image img');
      if (!activeImage) return;

      activeImage.loading = 'eager';

      if (!activeImage.complete) {
        var src = activeImage.getAttribute('src');
        if (src) {
          activeImage.src = src;
        }
      }
    });
  };

  PlanSelectWidget.prototype.onVariantChange = function(sectionId, variantId) {
    if (String(sectionId || '') !== this.sectionId) return;
    this.selectedVariantId = String(variantId || this.selectedVariantId || '');
    this.refresh();
  };

  function initWidgets(scope) {
    var nodes = (scope || document).querySelectorAll(WIDGET_SELECTOR);
    nodes.forEach(function(node) {
      if (node.dataset.planSelectReady === 'true') return;
      node.dataset.planSelectReady = 'true';
      widgetRegistry.push(new PlanSelectWidget(node));
    });
  }

  function bindVariantSubscription() {
    if (variantSubscription) return;
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS || !PUB_SUB_EVENTS.variantChange) return;

    variantSubscription = subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
      if (!event || !event.data) return;

      var sectionId = String(event.data.sectionId || '');
      var variantId = event.data.variant && event.data.variant.id ? String(event.data.variant.id) : '';

      widgetRegistry.forEach(function(widget) {
        widget.onVariantChange(sectionId, variantId);
      });
    });
  }

  function start() {
    initWidgets(document);
    bindVariantSubscription();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initWidgets(event.target);
  });
})();
